module.exports = __webpack_public_path__ + "static/media/UZ.f32eacef.svg";